import { useRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import titleCaseString from "../../utils/titleCaseUtils";
import useUpdate from "../../hooks/useUpdate";
import DateFormatter from "../../utils/dateFormatterUtils";
import Swal from "sweetalert2";
import LoadingAnimation from "../../components/Loading";
import ImageGallery from "react-image-gallery";


/* HOOKS */
import useCachedTransactions from "../../hooks/useFetchWithCache";

/* CSS */ 
import "../../styles/pages/page-profile.css";
import "../../styles/image-gallery.css";
import { height, width } from "@mui/system";
import { isValidFile, getFilePath } from "../../utils/imageValidatorUtils";

/* CUSTOM SERVICES */
import apiRequest from "../../services/apiService";

/* AMPLIFY */
import { generateClient } from "aws-amplify/api";
import useModelData from "../../hooks/useModelData";

/* SUBSCRIPTION FOR PINGING WEBSOCKET AND REAL-TIME UPDATES */
import {
  onCreateTransaction,
  onUpdateTransaction,
  onDeleteTransaction,
  onUpdateChatNegotiation,
} from "../../graphql/subscriptions";

import {
  onCreateTransactionLawyer,
  onUpdateTransactionLawyer,
  onDeleteTransactionLawyer,
} from "../../graphql/subscriptions";

/* MUTATIONS IS FOR INSERT , UPDATE AND DELETE */
/* MUTATIONS FOR CREATE , UPDATE AND DELETE */
import {
  createTransactionLawyer,
  updateTransactionLawyer,
  deleteTransactionLawyer,
  updateTransaction,
  updateChatNegotiation,
  createChatMessage,
  createChatNegotiation,
} from "../../graphql/mutations";

import LoadingAnimationWaitingForPrincipal from "./techoath_loading_waiting_principal";

import { useAuth } from "../../contexts/AuthContext";



/* QUERIES FOR LIST */
import {
  listTransactions,
  listTransactionLawyers,
  listChatNegotiation,
} from "../../graphql/queries";
import TechOathChat from "./techoath_chat";
import DateTimeSelection from "./techoath_select_date_time";

import { format } from "date-fns";

import useSendSMS from '../../hooks/useSendSMS';
import useSendEmail from "../../hooks/useSendEmail";
import useSendPushNotification from "../../hooks/useSendPushNotification";
import Maps from "../../components/Maps";


/* PDF VIEWER */
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";
import Spinner from "../../components/Spinner";
import BackdropModalSmall from "../../components/modals/backdrop_modal_small";
import CurrencyInput from "react-currency-input-field";


const TechOathDetails = ({
  selectedItem,
  handleDelete,
  currentTransactionId,
  handleDeleteTransactionLawyer,
  setOpen,
}) => {

  console.log("hewhew",selectedItem);
  const { user, location, errorLocation } = useAuth();
  const user_id                           = user.user_id;
  const fullname                          = `${user.first_name} ${user.last_name}`;
  const user_profile_photo                = user.user_profile_photo;

  const [currentAcceptedTransactionLawyerId, setCurrentAcceptedTransactionLawyerId] = useState("");
  const [currentlyDoingOfPrincipal, setCurrentlyDoingOfPrincipal] = useState("");
  const [acceptedLawyer, setAcceptedLawyer] = useState("");


  const [currentStatus,setCurrentStatus] = useState("");



  // PDF VIEWER
  const [isImage, setIsImage] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;


  const fullScreenPluginInstance = fullScreenPlugin();
  const { EnterFullScreenButton } = fullScreenPluginInstance;





  // Fetch the initial transactions
  useEffect(() => {
    // Subscribe to real-time updates when a transaction is updated
    const updateSub = client.graphql({ query: onUpdateTransaction }).subscribe({
      next: ({ data }) => {
        const updatedTransaction = data.onUpdateTransaction;
        const transaction_status = updatedTransaction.transaction_status;
        setCurrentlyDoingOfPrincipal(transaction_status);
        setAcceptedLawyer(updatedTransaction.lawyer_id)
      },
      error: (error) => {
        console.warn("Subscription error:", error);
      },
    });

    // Cleanup subscriptions on component unmount
    return () => {
      updateSub.unsubscribe();
    };
  }, []);

  const [acceptedTransaction, setAcceptedTransaction] = useState(false);
  const client = generateClient();

  // Fetch the initial transactions
  useEffect(() => {
    // Subscribe to real-time updates when a transaction is updated
    const updateSub = client
      .graphql({ query: onUpdateTransactionLawyer })
      .subscribe({
        next: ({ data }) => {
          const updatedTransaction = data.onUpdateTransactionLawyer;

          console.log("updatedTransaction", updatedTransaction);

          const document_status = updatedTransaction.document_status;
          const transaction_status = updatedTransaction.transaction_status;

          if (
            document_status === "ACCEPTED" &&
            transaction_status === "ACCEPTED"
          ) {
            setAcceptedTransaction(true);
            setCurrentStatus("ACCEPTED");
            //setIsSubmitting(false);
          } else if(document_status === "ACCEPTED" &&
            transaction_status === "REJECTED") {

            setAcceptedTransaction(false);
            setCurrentStatus("REJECTED");
            console.log("dito");
          }
        },
        error: (error) => {
          console.warn("Subscription error:", error);
        },
      });

    // Cleanup subscriptions on component unmount
    return () => {
      updateSub.unsubscribe();
    };
  }, []);

  const updateTransactioLawyer = async () => {
    const updateVariables = {
      input: {
        id: currentTransactionId,
        document_status: "ACCEPTED",
      },
      condition: {
        transaction_id: { eq: transaction_id },
      },
    };

    // Step 3: Call the update mutation
    const updateResponse = await client.graphql({
      query: updateTransactionLawyer, // The mutation to update the user status
      variables: updateVariables,
    });

    console.log(
      "User status updated:",
      updateResponse.data.updateTransactionLawyer
    );
  };

  const [fetchErrorMessage, setFetchErrorMessage] = useState(null);
  

  const {
      transactionDetailsInApi,
      isLoading:isLoadingDetailsInApi
    } = useCachedTransactions(
      selectedItem?.transaction_id,
      apiRequest,
      setFetchErrorMessage
    );


  
  /*const [transactionDetailsInApi, setTransactionDetailsInApi] = useState(null);
  useEffect(() => {
    const loadTransaction = async () => {
      try {
        const data = await apiRequest("get", `/transactions/${selectedItem.transaction_id}/`);
        setTransactionDetailsInApi(data);
      } catch (error) {
        setFetchErrorMessage(error.message);
      }
    };

    loadTransaction();
  }, [selectedItem]);*/
 
  

  const { updateData, isLoading, errorMessage, successMessage } = useUpdate();
  const transaction_status = selectedItem.transaction_status;
  const transaction_id = transactionDetailsInApi?.transaction_id;

  const defaultImagePath = "/iusevolutione/assets/img/no-attachment.svg";

  // Check if the selected item files are valid
  const attachmentIsValid = isValidFile(transactionDetailsInApi?.document_attachment);
  const signatureIsValid  = isValidFile(transactionDetailsInApi?.signature_file);
  const iDIsValid         = isValidFile( transactionDetailsInApi?.attachment_id_file);



  const requestFor = transactionDetailsInApi?.request_for_other?.trim().toUpperCase() ?? 'FIRST PARTY';



  
  useEffect(() => {
    if (transactionDetailsInApi?.document_attachment) {
      setPreviewUrl(transactionDetailsInApi?.document_attachment);

      const extension = transactionDetailsInApi?.document_attachment.split(".").pop().toLowerCase();

      if (extension === "pdf") {
        setIsPDF(true);
        setIsImage(false);
      } else if (["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(extension)) {
        setIsImage(true);
        setIsPDF(false);
      } else {
        setIsImage(false);
        setIsPDF(false);
      }
    }

    console.log(selectedItem.transaction_id);
  }, [transactionDetailsInApi]);

    const [pdfData, setPdfData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorPdf, setErrorPdf] = useState(null);

    useEffect(() => {
        if (!transactionDetailsInApi?.document_attachment) return;

        setLoading(true);
        setErrorPdf(null);

        // Abort if component unmounts before fetch completes
        const controller = new AbortController();

        fetch(transactionDetailsInApi.document_attachment, { signal: controller.signal })
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to load PDF");
                }
                return res.blob();
            })
            .then((blob) => {
                const fileUrl = URL.createObjectURL(blob);
                setPdfData(fileUrl);
                setLoading(false);
            })
            .catch((err) => {
                if (err.name !== "AbortError") {
                    console.error("Error loading PDF:", err);
                    setErrorPdf("Failed to load PDF");
                    setLoading(false);
                }
            });

        return () => {
            controller.abort(); // Cancel the fetch if the component unmounts
        };
    }, [transactionDetailsInApi]);









  const images = [
    // {
    //   original   : getFilePath(transactionDetailsInApi?.document_attachment, defaultImagePath),
    //   thumbnail  : getFilePath(transactionDetailsInApi?.document_attachment, defaultImagePath),
    //   originalAlt: attachmentIsValid ? "Uploaded Document(s)" : "No Uploaded Document(s)",
    //   description: attachmentIsValid ? "Uploaded Document(s)" : "No Uploaded Document(s)",
    // },attachment_id_number
    {
      original     : getFilePath(requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_signature_file : transactionDetailsInApi?.signature_file, defaultImagePath),
      thumbnail    : getFilePath(requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_signature_file :transactionDetailsInApi?.signature_file, defaultImagePath),
      originalAlt  : signatureIsValid ? "Signature" : "No Signature",
      originalTitle: signatureIsValid ? "Signature" : "No Signature",
      description  : signatureIsValid ? "Signature" : "No Signature",
    },
    {
      original   : getFilePath(requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_attachment_id_file : transactionDetailsInApi?.attachment_id_file, defaultImagePath),
      thumbnail  : getFilePath(requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_attachment_id_file : transactionDetailsInApi?.attachment_id_file, defaultImagePath),
      originalAlt: iDIsValid ? "Government ID" : "No Government ID Image",
      description: iDIsValid ? "Government ID" : "No Government ID Image",
    },
  ];


  
  const imageAttachment = [
    {
      original   : getFilePath(requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_document_attachment : transactionDetailsInApi?.document_attachment, defaultImagePath),
      thumbnail  : getFilePath(requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_document_attachment : transactionDetailsInApi?.document_attachment, defaultImagePath),
      originalAlt: attachmentIsValid ? "Uploaded Document(s)" : "No Uploaded Document(s)",
      description: attachmentIsValid ? "Uploaded Document(s)" : "No Uploaded Document(s)",
    },
  ];

  // ADD TRANSACTION LAWYER
  const createTransactionLawyerHandler = async () => {
    setCurrentStatus("");

    const input = {
      user_profile_id   : selectedItem.user_profile_id,
      document_status   : "ACCEPTED",
      transaction_id    : selectedItem.transaction_id,
      transaction_status: "WAITING",
      transaction_type  : "REQUEST",
      lawyer_name       : "ATTY. " + fullname?.toUpperCase(),
      // document_price    : selectedItem.document_price,
      document_price    : amount,
      created_by        : user_id,
      user_location     : location,
      user_profile_photo: user_profile_photo,
    };

    const user_profile_id = selectedItem.user_profile_id;
    const transaction_id = selectedItem.transaction_id;

    const filter = {
      created_by: { eq: user.user_id },
      transaction_id: { eq: transaction_id },
    };

    const variables = { filter };

    console.log(variables);

    try {
      // Step 1: Check if the user already exists
      const checkResponse = await client.graphql({
        query: listTransactionLawyers,
        variables: variables,
      });

      console.log("checkResponse", checkResponse);

      if (checkResponse.data.listTransactionLawyers.items.length > 0) {
        console.log("User status already exists, updating...");

        // Step 2: If the user exists, get the ID and update the user status
        const existingStatus = checkResponse.data.listTransactionLawyers.items[0]; // Take the first item (you may need to adjust if there are multiple)
        const checkIfAlreadyAcceptedByBothSides = checkResponse.data.listTransactionLawyers.items[0].transaction_status;
        if (checkIfAlreadyAcceptedByBothSides === "ACCEPTED") {
          setCurrentStatus(checkIfAlreadyAcceptedByBothSides);
        } else {
          console.log(existingStatus);
          // Define the update mutation variables
          const updateVariables = {
            input: {
              id: existingStatus.id, // The ID of the existing user status
              document_status   : "ACCEPTED",
              transaction_status: "WAITING",
              transaction_type  : "REQUEST",
              lawyer_name       : "ATTY. " + fullname?.toUpperCase(),
              document_price    : amount,
            },
            condition: {
              user_profile_id: { eq: selectedItem.user_profile_id },
              transaction_id: { eq: selectedItem.transaction_id }, // The condition to ensure we update the correct user
            },
          };

          setCurrentAcceptedTransactionLawyerId(existingStatus.id);

          // Step 3: Call the update mutation
          const updateResponse = await client.graphql({
            query: updateTransactionLawyer, // The mutation to update the user status
            variables: updateVariables,
          });
          console.log(
            "User status updated2:",
            updateResponse.data.updateTransactionLawyer
          );
        }

        return;
      }

      // Step 3: If user doesn't exist, create a new user status
      const mutationVariables = { input };
      const mutationResponse = await client.graphql({
        query: createTransactionLawyer,
        variables: mutationVariables,
      });

      const newTransaction = mutationResponse.data.createTransactionLawyer;

      setCurrentAcceptedTransactionLawyerId(newTransaction.id);

      console.log("Lawyer Transaction created:", newTransaction);
    } catch (error) {
      console.error("Error handling user status:", error);
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (status) => {
  const result = await Swal.fire({
    title: 'Terms and Conditions',
    html: `
      <div style="height: 200px; overflow-y: scroll; text-align: left; padding: 10px; border: 1px solid #ccc;">
        <p><strong>1. Agreement to Terms</strong></p>
        <p>By proceeding, you agree to the following conditions...</p>
        <p><strong>2. Confidentiality</strong></p>
        <p>All data must remain confidential...</p>
        <p><strong>3. Legal Liability</strong></p>
        <p>You are responsible for the legal accuracy of this submission...</p>
        <!-- Add more terms here -->
      </div>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Agree',
    cancelButtonText: 'Cancel',
    customClass: {
      container: 'swal2-container',
    },
    allowOutsideClick: false,
    confirmButtonColor: '#e39a06',
    cancelButtonColor: '#ff3e1d',
  });

  if (result.isConfirmed) {
    setOpenAmount(true);
    setTimeout(() => {
      inputAmountRef.current.focus();
    }, 500);
  } else {
    console.log("Terms not accepted.");
  }
};


  // const handleSubmit = async (status) => {
  //   console.log(location);

  //   let formField = new FormData();

  //   formField.append("transaction_status", status);

  //   const result = await Swal.fire({
  //     title: `Do you wants to ${
  //       status === "DENIED" ? "deny" : "accept"
  //     } application?`,
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes,proceed!",
  //     cancelButtonText: "No, cancel",
  //     customClass: {
  //       container: "swal2-container",
  //     },
  //   });

  //   if (result.isConfirmed) {
  //     try {
  //       setIsSubmitting(true);

  //       createTransactionLawyerHandler();

  //       //updateTransactioLawyer(transaction_id);

  //       //await updateData(`${process.env.REACT_APP_API_URL}/transactions/${transaction_id}/`, formField, () => {});

  //       // handleDelete(selectedItem);
  //     } catch (error) {
  //       console.error("Error updating data:", error);
  //     }
  //   } else if (result.dismiss === Swal.DismissReason.cancel) {
  //     console.log("Submission cancelled.");
  //   }
  // };


  



  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const { sendSMS, response, error }                            = useSendSMS();
  const { sendEmail, responseEmail, errorEmail }                = useSendEmail();
  const { sendPushNotification, response:responsePushNotif, error:errorPushNotif } = useSendPushNotification();


  const handleSaveSchedule = () => {
    updateTransactionStatus("FOR PAYMENT");
  }


  const { updateItem:updateItemChatNegotiation } = useModelData({
    model: "ChatNegotiation",
    queries: {
      update: updateChatNegotiation,
    },
    subscriptions: {
      onUpdate: onUpdateChatNegotiation,
    }
  });


    // REJECTED TRANSACTIONS
    const filterLawyerCount = {
      
      and: [
          { transaction_id: { eq: selectedItem.transaction_id } },
          { document_status: { eq:'ACCEPTED' } }
        ]
      
      };

  const { dataAmplify, updateItem: updateItemTransactionLawyer } = useModelData({
    model: "TransactionLawyer",
    queries: {
      list: listTransactionLawyers,
      update: updateTransactionLawyer,
    },
    subscriptions: {
      onCreate: onCreateTransactionLawyer,
      onUpdate: onUpdateTransactionLawyer,
      onDelete: onDeleteTransactionLawyer,
    },
    filter: filterLawyerCount,
  });


  
  


   const [chatError, setChatError] = useState(false);
    const handleCreateChatNegotiation = async () => {
      setChatError(false);
      const input = {
        status        : "APPROVED",
        lawyer_id     : user_id,
        transaction_id: selectedItem.transaction_id,
        date_created  : format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        
      };
      try {
        const mutationVariables = { input };
        await client.graphql({
          query    : createChatNegotiation,
          variables: mutationVariables,
        });
      } catch (error) {
        setChatError(true);
      }
    };
  


  const { updateItem,checkItemExists } = useModelData({
    model: "Transaction",
    queries: {
      update: updateTransaction,
    },
    subscriptions: {
      onUpdate: onUpdateTransaction,
    }
  });

  const updateTransactionStatus = async(newStatus) => {
    let finalDate = format(new Date(selectedDate), "yyyy-MM-dd HH:mm:ss");
    const formattedDate = format(selectedDate, "MMMM dd, yyyy");
    const formattedTime = format(selectedDate, "h:mm a");

    const updateInput = {
      id                : selectedItem.id,
      transaction_status: newStatus,
      scheduled_status  : "APPROVED",
      scheduled_at      : finalDate
    };

    await updateItem(updateInput);


    const filter = { transaction_id: { eq: selectedItem.transaction_id }};
      try {
        const exists = await checkItemExists(listChatNegotiation, filter);
        if (exists) {
          console.log("Item exists, updating...",exists);
          const updateChatNegotiation = {
            id       : exists.id,
            status   : "APPROVED",
            lawyer_id: user_id,
          };
          updateItemChatNegotiation(updateChatNegotiation)
        }
        else{
          await handleCreateChatNegotiation();
        }
      } catch (error) {
        console.error('Error handling user status:', error);
      }

   

    await sendPushNotification(selectedItem.registration_id, "", "Application Accepted", `Your schedule is on: ${formattedDate} at ${formattedTime}`, "Schedule", "notification_user" );

    setIsScheduleOpen(false);
    setOpen(false);
  };


  
  const [activeTab, setActiveTab] = useState('transactions');



    // Confirm Amount
    const [amount,setAmount] = useState("")
    const handleValueChange = (value) => {
      setAmount(value);
    };
    const [openAmount, setOpenAmount] = useState(false);
    
    const handleCloseAmount = () => {
      setOpenAmount(false);
    };
  
    const inputAmountRef = useRef(null);
  
    function handleConfirmAmount(status) {
      setOpenAmount(true)
     
    }

    const handleSaveAmount = async (e) => {
       setIsSubmitting(true);
        let formField = new FormData();
        formField.append("transaction_status", "FOR OATH");
        createTransactionLawyerHandler();
        setOpenAmount(false);
    }

const [openChat,setOpenChat] = useState(false);



  const [chatId, setChatId] = useState("");


  useEffect(() => {
    if(currentStatus==="REJECTED"){
         Swal.fire({
                  title: 'Transaction Called Off.',
                  icon: 'error',
                  text: 'Client decided to cancel this transaction.',
                  customClass: {
                    confirmButton: 'btn btn-success'
                  },
                  confirmButtonColor: '#03c3ec',
                  cancelButtonColor: '#ff3e1d',
            });

      setOpenChat(false);
      setOpenAmount(false);
      setChatId("");
      // setOpen(false);
    }
  }, [currentStatus]);



   useEffect(() => {
     console.log("dataAmplify",dataAmplify);
  }, [dataAmplify]);





  useEffect(()=>{
      console.log("chatIdGG",chatId);

  },[chatId])



     // 🔒 LOADING STATE
    if (isLoadingDetailsInApi) {
      return <div>Loading transaction...</div>;
    }

    // ❌ NO DATA
    if (!transactionDetailsInApi) {
      return <div>No transaction data</div>;
    }
    
 

  return (
    <>

    <BackdropModalSmall open={openAmount} handleClose={handleCloseAmount} modalTitle="Kindly indicate the figure you would like to negotiate. (Amount)" >
          <div className="card-footer shadow-xs">
            <div className="d-flex justify-content-between align-items-center ">
              <CurrencyInput
                ref={inputAmountRef}
                value={amount}
                onValueChange={handleValueChange}
                intlConfig={{ locale: "en-PH", currency: "PHP" }}
                prefix="₱"
                decimalsLimit={2}
                groupSeparator=","
                decimalSeparator="."
                placeholder="Indicate the amount here..."
                className="form-control message-input border-0 me-4 shadow-none"
              />

              <div className="message-actions d-flex align-items-center">
                <button type="button" onClick={(e) => { 
                  handleSaveAmount(e);
                  }} className="btn btn-warning d-flex send-msg-btn" >
                  <span className="align-middle d-md-inline-block d-none">
                    Save
                  </span>
                  <i className="icon-base bx bx-save icon-sm ms-md-2 ms-0" />
                </button>
              </div>
            </div>
          </div>
        </BackdropModalSmall>





      {fetchErrorMessage &&
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" />
          <strong>
            {fetchErrorMessage.response?.status === 404
              && "Transaction not found in the database."}
          </strong>
        </div>




                          }

      {!transactionDetailsInApi && !fetchErrorMessage && <LoadingAnimation />}
      {selectedItem && (
        <>
          {isSubmitting && (
            <LoadingAnimationWaitingForPrincipal
              selectedItem                       = {selectedItem}
              acceptedTransaction                = {acceptedTransaction}
              currentlyDoingOfPrincipal          = {currentlyDoingOfPrincipal}
              acceptedLawyer={acceptedLawyer}
              handleDeleteTransactionLawyer      = {handleDeleteTransactionLawyer}
              currentAcceptedTransactionLawyerId = { currentAcceptedTransactionLawyerId }
              setOpen                            = {setOpen}
              openChat={openChat}
              setOpenChat={setOpenChat}
              setChatId={setChatId}
              chatId={chatId}
            />
          )}
          {isScheduleOpen && (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", position: "fixed", top: 0, left: 0, width: "100%", backgroundColor: "rgba(1, 1, 1, 0.8)", zIndex: 1000, }} >
              <div className="d-flex flex-column align-items-center p-4 rounded" style={{ backgroundColor: "rgba(255, 255, 255, 1)" }} >

                <DateTimeSelection
                  isScheduleOpen     = {isScheduleOpen}
                  handleSaveSchedule = {handleSaveSchedule}
                  selectedDate       = {selectedDate}
                  setSelectedDate    = {setSelectedDate}
                  preselectedDate    = {selectedItem.scheduled_at}
                />

                {selectedItem.scheduled_at && (
                  <div style={{ marginTop: "20px" }}>
                    <strong>
                      Tentative Schedule:{format(new Date(selectedItem.scheduled_at), "MMMM d, yyyy @ h:mm a")}
                    </strong>
                  </div>
                )}

                {selectedDate && (
                  <div style={{ marginTop: "20px" }}>
                    <strong>
                      Selected Date & Time:{" "}
                      {format(new Date(selectedDate), "MMMM d, yyyy @ h:mm a")}
                    </strong>
                    <button type="button" className="btn btn-primary d-flex  w-100" onClick={handleSaveSchedule}>
                      <span className="align-middle d-md-inline-block ">
                        Save
                      </span>
                      <i className="icon-base bx bx-save icon-sm ms-md-2 ms-0" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}




          {isLoading && <LoadingAnimation />}
          {errorMessage && (
            <div className="alert alert-danger">{String(errorMessage)}</div>
          )}
          {successMessage && <div className="success">{successMessage}</div>}

          <div className="container-xxl flex-grow-1 p-0 m-0">
            <div className="col-12">
              <div className="card mb-4">
                <div className="user-profile-header-banner">
                  {/* <img src="/iusevolutione/assets/img/pages/profile-banner.png" alt="Banner" className="rounded-top" /> */}
                  <Maps location={selectedItem.user_location} />
                </div>
                <div className="user-profile-header d-flex flex-column flex-sm-column flex-md-row text-center text-lg-start mb-4 z-1 ">
                  <div className="flex-shrink-0 mt-n2 mx-auto">
                    <img
                      src={(selectedItem.user_profile_photo ?? transactionDetailsInApi?.attachment_id_file) || "/iusevolutione/assets/img/no-attachment.svg"}
                      alt="user"
                      className="d-block ms-0 ms-sm-4 rounded user-profile-img"
                      style={{objectFit:"cover",height:230,width:225}}
                    />

                    
                  </div>
                  <div className="flex-grow-1 mt-3 mt-sm-5  mx-auto">
                    <div className="d-flex  flex-column gap-4">
                      <div className="user-profile-info ms-4">
                   
                        <h4 className="mb-1 responsive-text fw-bold">
                          {requestFor==="SECOND PARTY" ? selectedItem.second_party_full_name?.toUpperCase() : selectedItem.full_name?.toUpperCase()}
                        </h4>



                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-lg-start  text-center text-lg-start justify-content-center gap-2">
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-map" />
                            <span>
                              {`
                                ${titleCaseString(transactionDetailsInApi?.country || "Philippines")},
                                ${titleCaseString(transactionDetailsInApi?.province)},
                                ${titleCaseString(transactionDetailsInApi?.city)},
                                Brgy. ${titleCaseString(transactionDetailsInApi?.barangay ?? "")}
                              `}
                            </span>
                            
                          </li>

                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-phone" />
                            <span className="fw-medium mx-2 d-sm-inline-block d-none me-sm-1">Contact:</span>
                            <span>
                              {requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_contact_number : transactionDetailsInApi?.contact_number}
                            </span>
                          </li>
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-envelope" />
                            <span className="fw-medium mx-2 d-sm-inline-block d-none me-sm-1">Email:</span>
                            <span>{requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_email : transactionDetailsInApi?.email}</span>
                          </li>
                        </ul>

                        {!fetchErrorMessage && <>
                          {(transaction_status.toUpperCase() === "PENDING" || transaction_status.toUpperCase() === "FOR SCHEDULE") &&
                            <div className="d-flex w-100 justify-content-center justify-content-lg-end gap-2 mt-3 pe-4">
                              {selectedItem.transaction_type.toUpperCase() === "WALK-IN" ?
                                <button type="button" onClick={() => setIsScheduleOpen(true)} className="btn btn-warning" >
                                  Accept Application & Select Schedule
                                </button>
                                :
                                <button type="button" onClick={() => handleSubmit("FOR OATH")} className="btn btn-warning" >
                                  Accept Application
                                </button>
                              }
                            </div>
                          }
                        </>
                        }

                       


                        {dataAmplify && (
                          <div className="d-flex w-100 justify-content-end gap-2 mt-3 pe-4 d-none d-lg-block d-md-block">
                            {dataAmplify.filter(item => item.document_status === "ACCEPTED").length > 0 ? (
                              <span className="fw-bold">
                                THERE {
                                  dataAmplify.filter(item => item.document_status === "ACCEPTED").length > 1 ? 'ARE' : 'IS'
                                } (
                                <span className="text-info">
                                  {dataAmplify.filter(item => item.document_status === "ACCEPTED").length}
                                </span>) {
                                  dataAmplify.filter(item => item.document_status === "ACCEPTED").length > 1
                                    ? 'LAWYERS'
                                    : 'LAWYER'
                                } WHO HAS ACCEPTED THIS TRANSACTION.
                              </span>
                            ) : (
                              <span className="fw-bold">
                                THIS TRANSACTION <span className="text-danger">HAS NOT</span> BEEN ACCEPTED BY ANY LAWYER.
                              </span>
                            )}
                          </div>
                        )}


                        


                      </div>


                 

                    </div>

                  </div>

                  <div className="d-flex w-100 justify-content-center d-lg-none d-sm-block d-md-none  text-center mt-2">
                    {dataAmplify?.length > 0 ? (
                      <span className="fw-bold">
                        THERE {dataAmplify.length > 1 ? 'ARE' : 'IS'} (<span className="text-info">{dataAmplify.length}</span>) {dataAmplify.length > 1 ? 'LAWYERS' : 'LAWYER'} WHO HAS ACCEPTED THIS TRANSACTION.
                      </span>
                    ) : (
                      <span className="fw-bold">THIS TRANSACTION <span className="text-danger">HAS NOT</span> BEEN ACCEPTED BY ANY LAWYER.</span>
                    )}
                  </div>


                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <ul className="nav nav-pills flex-row flex-sm-row mb-4">
                  <li className="nav-item">
                    <button type="button" className={`nav-link ${activeTab === 'transactions' ? 'active' : 'btn-label-secondary'}`} onClick={() => setActiveTab('transactions')}>
                      <i className="bx bx-pencil me-1" /> 
                      <span className="align-middle d-sm-inline-block d-none me-sm-1">Information</span>
                    </button>
                  </li>


                  {!fetchErrorMessage &&
                    <li className="nav-item">
                      <button type="button" className={`nav-link ${activeTab === 'participants' ? 'active' : 'btn-label-secondary'}`} onClick={() => setActiveTab('participants')}>
                        <i className="bx bx-group me-1" />
                        <span className="align-middle d-sm-inline-block d-none me-sm-1">Participants</span>
                      </button>
                    </li>
                  }


                </ul>
              </div>
            </div>

          {activeTab === 'transactions' && 
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6  order-2 order-md-1 mt-4 mt-md-0 mt-lg-0">
                  {/* {transactionDetailsInApi &&
                    <div className="card mb-4">
                      <div className="card-body">
                        <small className="text-muted text-uppercase">
                          User Information
                        </small>
                        <ul className="list-unstyled mb-0 mt-3">
                          <li className="d-flex align-items-center mb-3">
                            <i className="bx bx-user" />
                            <span className="fw-medium mx-2">Fullname:</span>{" "}
                            <span>

                              {transactionDetailsInApi.request_for_other.trim().toUpperCase() === "SECOND PARTY"

                                ?

                                titleCaseString(
                                  transactionDetailsInApi.second_party_first_name?.toUpperCase() +
                                  " " +
                                  transactionDetailsInApi.second_party_last_name?.toUpperCase()
                                )

                                :

                                titleCaseString(
                                  transactionDetailsInApi.first_name?.toUpperCase() +
                                  " " +
                                  transactionDetailsInApi.last_name?.toUpperCase()
                                )}



                            </span>
                          </li>

                          <li className="d-flex align-items-center mb-3">
                            <i className="bx bx-male-female" />
                            <span className="fw-medium mx-2">Gender:</span>{" "}
                            <span>{
                              requestFor === "SECOND PARTY" ?
                                titleCaseString(transactionDetailsInApi.second_party_gender) :
                                titleCaseString(transactionDetailsInApi.gender)
                            }</span>
                          </li>

                          <li className="d-flex align-items-center">
                            <i className="bx bx-calendar" />
                            <span className="fw-medium mx-2">Birthdate:</span>{" "}
                            <span>



                              {requestFor === "SECOND PARTY" ?
                                DateFormatter(transactionDetailsInApi.second_party_birth_date, "MM DD, YYYY")
                                :
                                DateFormatter(transactionDetailsInApi.birth_date, "MM DD, YYYY")
                              }
                            </span>
                          </li>

                        </ul>
                       
                      </div>
                    </div>
                  } */}

                  <div className="card">
                    <div className="card-body">
                      <small className="text-muted text-uppercase">
                        ID AND Attachments
                      </small>

                      <ul className="list-unstyled mb-4 mt-3">
                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-id-card" />
                          <span className="fw-medium mx-2">ID:</span>{" "}
                          <span>
                            {requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_attachment_id_type : transactionDetailsInApi?.attachment_id_type}
                          </span>
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-credit-card-front" />
                          <span className="fw-medium mx-2">ID Number:</span>{" "}
                          <span>{
                            requestFor === "SECOND PARTY" ? transactionDetailsInApi?.second_party_attachment_id_number : transactionDetailsInApi?.attachment_id_number
                          }</span>
                        </li>

                        <li className="d-flex align-items-center mb-3 w-100" style={{ minHeight: 375 }} >

                          <ImageGallery
                            showPlayButton={false}
                            style={{ height: 100 }}
                            items={images}
                            showThumbnails={false}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>


                <div className="col-xl-6 col-lg-6 col-md-6  order-1 order-md-2">
                  <div className="card card-action   mb-4">
                    <div className="card-header align-items-center pb-2">
                      <h5 className="card-action-title mb-0">
                        <i className="bx bx-info-circle me-2" />
                        Transaction Information
                      </h5>
                    </div>

                    <div className="card-body">
                      {/* <ul className="list-unstyled mb-4 mt-3 d-none d-md-block d-lg-block">
                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-check me-2" />
                          <span className="fw-medium mx-2 d-sm-inline-block d-none">Transaction</span>#
                          <span>
                            {selectedItem.transaction_id}
                          </span>
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-info-circle me-2" />
                          <span className="fw-medium mx-2 d-sm-inline-block d-none">Status:</span>
                          <span>
                            {titleCaseString(selectedItem.transaction_status)}
                          </span>
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bxs-file-doc me-2" />
                          <span className="fw-medium mx-2 d-sm-inline-block d-none">
                            Document Type :
                          </span>
                          <span className="fw-bold">
                            {selectedItem.document_name?.toUpperCase() === "TITLE YOUR DOCUMENT" ? selectedItem.document_title.toUpperCase() : selectedItem.document_name?.toUpperCase()}
                          </span>
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-calendar-alt me-2" />
                          <span className="fw-medium mx-2 d-sm-inline-block d-none">Date Created :</span>
                          {DateFormatter(
                            selectedItem.date_created,
                            "MM DD, YYYY"
                          )}
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-flag me-2" />
                          <span className="fw-medium mx-2">
                            Inside the Philippines :
                          </span>
                          <span>
                            {titleCaseString(transactionDetailsInApi?.is_inside_philippines)}
                          </span>
                        </li>



                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-dollar-circle me-2" />
                          <span className="fw-medium mx-2 d-sm-inline-block d-none">Price :</span>{" "}
                          <span className="fw-bold text-gray-900 blinking">
                            {selectedItem.document_price} -{" "}
                            {selectedItem.transaction_payment_status}{" "}
                          </span>
                          <span className="badge bg-label-success">
                            Ref#: {selectedItem.reference_number}
                          </span>
                        </li>
                      </ul> */}


                      <ul className="p-0 m-0 mt-4 d-flex flex-lg-row flex-column">
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                            <li className="d-flex mb-4 pb-1">
                              <div className="avatar flex-shrink-0 me-3">
                                <span className="avatar-initial rounded bg-label-warning"><i className="bx bx-check"></i></span>
                              </div>
                              <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div>
                                  <h6 className="mb-0">{selectedItem.transaction_id}</h6>
                                  <small className="text-muted d-block mb-1">Transaction #</small>
                                </div>
                              </div>
                            </li>
                          </div>

                          <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                            <li className="d-flex mb-4 pb-1">
                              <div className="avatar flex-shrink-0 me-3">
                                <span className="avatar-initial rounded bg-label-warning"><i className="bx bx-info-circle"></i></span>
                              </div>
                              <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div>
                                  <h6 className="mb-0">{titleCaseString(selectedItem.transaction_status)}</h6>
                                  <small className="text-muted d-block mb-1">Status</small>
                                </div>
                              </div>
                            </li>
                          </div>


                          <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                            <li className="d-flex mb-4 pb-1">
                              <div className="avatar flex-shrink-0 me-3">
                                <span className="avatar-initial rounded bg-label-warning"><i className="bx bxs-file-doc"></i></span>
                              </div>
                              <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div>
                                  <h6 className="mb-0">
                                    {selectedItem.document_name?.toUpperCase() === "TITLE YOUR DOCUMENT"
                                      ? selectedItem.document_title.toUpperCase()
                                      : selectedItem.document_name?.toUpperCase()}
                                  </h6>
                                  <small className="text-muted d-block mb-1">Document Title</small>
                                </div>
                              </div>
                            </li>
                          </div>

                          <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                            <li className="d-flex mb-4 pb-1">
                              <div className="avatar flex-shrink-0 me-3">
                                <span className="avatar-initial rounded bg-label-warning"><i className="bx bx-calendar"></i></span>
                              </div>
                              <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div>
                                  <h6 className="mb-0">{DateFormatter(selectedItem.date_created, "MM DD, YYYY")}</h6>
                                  <small className="text-muted d-block mb-1">Date Created</small>
                                </div>
                              </div>
                            </li>
                          </div>

                          <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                            <li className="d-flex mb-4 pb-1">
                              <div className="avatar flex-shrink-0 me-3">
                                <span className="avatar-initial rounded bg-label-warning"><i className="bx bx-flag"></i></span>
                              </div>
                              <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div>
                                  <h6 className="mb-0">{titleCaseString(transactionDetailsInApi?.is_inside_philippines)}</h6>
                                  <small className="text-muted d-block mb-1">Is inside the Philippines</small>
                                </div>
                              </div>
                            </li>
                          </div>

                          <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                            <li className="d-flex mb-4 pb-1">
                              <div className="avatar flex-shrink-0 me-3">
                                <span className="avatar-initial rounded bg-label-warning"><i className="bx bx-dollar-circle"></i></span>
                              </div>
                              <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div>
                                  <h6 className="mb-0 blinking">
                                    {selectedItem.document_price} - {selectedItem.transaction_payment_status}
                                    <span className="badge bg-label-success ms-2">
                                      Ref#: {selectedItem.reference_number}
                                    </span>
                                  </h6>
                                  <small className="text-muted d-block mb-1">Document Price</small>
                                </div>
                              </div>
                            </li>
                          </div>
                        </div>
                      </ul>

 

                      {/* <small className="text-muted text-uppercase">
                      Vehicle Information
                    </small>

                    <ul className="list-unstyled mb-4 mt-3">
                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bxs-car-mechanic" />
                        <span className="fw-medium mx-2">Category:</span>{" "}
                        <span>
                          {titleCaseString(selectedItem.vehicle_category)}
                        </span>
                      </li>
                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-car" />
                        <span className="fw-medium mx-2">Type:</span>{" "}
                        <span>
                          {titleCaseString(selectedItem.vehicle_type)}
                        </span>
                      </li>
                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-car" />
                        <span className="fw-medium mx-2">Vehicle:</span>{" "}
                        <span>{selectedItem.vehicle}</span>
                      </li>
                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-id-card" />
                        <span className="fw-medium mx-2">License:</span>{" "}
                        <span>{selectedItem.vehicle_license_category}</span>
                      </li>
                    </ul> */}

                      <small className="text-muted text-uppercase">
                        Miscellaneous Information
                      </small>

                      <ul className="list-unstyled mb-4 mt-3">
                        <li className="d-flex align-items-center mb-3">
                          <span className="badge badge-center rounded-pill bg-label-primary">
                            <i className="bx bx-question-mark" />
                          </span>
                          <span className="fw-medium mx-2"> Will the notarized document be used in the Philippines or abroad ?
                            <p className="fw-bolder d-inline ms-2 text-gray-900">{transactionDetailsInApi?.question_1}</p>
                          </span>
                        </li>



                        <li className="d-flex align-items-center mb-3">
                          <span className="badge badge-center rounded-pill bg-label-primary">
                            <i className="bx bx-question-mark" />
                          </span>
                          <span className="fw-medium mx-2"> Is your document signed by all signatories by hand (wet-signed) ?
                            <p className="fw-bolder d-inline ms-2 text-gray-900">{transactionDetailsInApi?.question_2}</p>
                          </span>

                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <span className="badge badge-center rounded-pill bg-label-primary">
                            <i className="bx bx-question-mark" />
                          </span>
                          <span className="fw-medium mx-2"> Were the signatories in the Philippines when they signed the document ?
                            <p className="fw-bolder d-inline ms-2 text-gray-900">{transactionDetailsInApi?.question_3}</p>
                          </span>
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <span className="badge badge-center rounded-pill bg-label-primary">
                            <i className="bx bx-question-mark" />
                          </span>
                          <span className="fw-medium mx-2"> Are the signatories currently in the Philippines?
                            <p className="fw-bolder d-inline ms-2 text-gray-900">{transactionDetailsInApi?.question_4}</p>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>


                 


                </div>


<div className="col-12  order-3 order-md-3">
 <div className="card">
                    <div className="card-header align-items-center pb-2">
                      <h5 className="card-action-title mb-0">
                        <i className="bx bx-info-circle me-2" />Uploaded Documents
                      </h5>
                    </div>
                    <div className="card-body">
                      {isImage && (
                        <ImageGallery
                          showPlayButton={false}
                          style={{ height: 100 }}
                          items={imageAttachment}
                          showThumbnails={false}
                        />
                      )}

                      {isPDF && (

                        <div style={{ overflowY: "auto" }}>
                          {loading && <div><Spinner color="primary" text={"Loading documents.."} withborder={true} /></div>}
                          {errorPdf && <div className="text-danger">{errorPdf}</div>}

                          {pdfData && (
                            <div className="pdf-viewer" style={{ maxHeight: 755 }}>
                              <Worker workerUrl="../js/pdf.worker.min.js">
                                <div className="mb-2 d-flex col-12 justify-content-center p-0">
                                  <ZoomOutButton />
                                  <ZoomPopover />
                                  <ZoomInButton />
                                  <EnterFullScreenButton plugin={fullScreenPluginInstance} />
                                </div>

                                <Viewer
                                  fileUrl={pdfData}
                                  plugins={[zoomPluginInstance, fullScreenPluginInstance]}
                                />
                              </Worker>
                            </div>
                          )}
                        </div>



                        // <div className="pdf-viewer" style={{ height: 250, maxHeight: 250 }}>
                        //   <Worker workerUrl="../js/pdf.worker.min.js">
                        //     <div className="mb-2 d-flex col-12 justify-content-center p-0">
                        //       <ZoomOutButton />
                        //       <ZoomPopover />
                        //       <ZoomInButton />
                        //       <EnterFullScreenButton plugin={fullScreenPluginInstance} />
                        //     </div>
                        //     <Viewer fileUrl={previewUrl} 
                        //     plugins={[zoomPluginInstance, fullScreenPluginInstance]}
                        //      />
                        //   </Worker>
                        // </div>
                      )}
                    </div>
                  </div>
 </div>

              </div>
            }



            {activeTab === 'participants' &&
            
              <div className="row">
                {/* 1st Party */}
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="card">
                    {transactionDetailsInApi &&
                      <div className="card-body">
                        <small className="fw-bolder text-black text-uppercase">
                          1st Party Information
                        </small>
                        <ul className="list-unstyled mb-4 mt-3">
                          <li className="d-flex align-items-center mb-3">
                            <i className="bx bx-user" />
                            <span className="fw-medium mx-2">Fullname:</span>{" "}
                            <span>
                              {titleCaseString(
                                transactionDetailsInApi.first_name?.toUpperCase() +
                                " " +
                                transactionDetailsInApi.last_name?.toUpperCase()
                              )}
                            </span>
                          </li>

                          <li className="d-flex align-items-center mb-3">
                            <i className="bx bx-male-female" />
                            <span className="fw-medium mx-2">Gender:</span>{" "}
                            <span>{titleCaseString(transactionDetailsInApi.gender)}</span>
                          </li>

                          <li className="d-flex align-items-center mb-3">
                            <i className="bx bx-calendar" />
                            <span className="fw-medium mx-2">Birthdate:</span>{" "}
                            <span>



                              {DateFormatter(
                                transactionDetailsInApi.birth_date,
                                "MM DD, YYYY"
                              )}
                            </span>
                          </li>

                        </ul>
                        <small className="text-muted text-uppercase">
                          Contacts
                        </small>
                        <ul className="list-unstyled mt-3">
                          <li className="d-flex align-items-center mb-3">
                            <i className="bx bx-phone" />
                            <span className="fw-medium mx-2">Contact:</span>
                            <span>{transactionDetailsInApi.contact_number}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="bx bx-envelope" />
                            <span className="fw-medium mx-2">Email:</span>
                            <span>{transactionDetailsInApi.email}</span>
                          </li>
                        </ul>
                      </div>
                    }

                  </div>
                </div>

 



                {/* 2nd Party */}
                {transactionDetailsInApi.second_party_first_name &&
                  <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className="card mb-4">
                      {transactionDetailsInApi &&
                        <div className="card-body">
                          <small className="fw-bolder text-black text-uppercase">
                            2nd Party Information
                          </small>
                          <ul className="list-unstyled mb-4 mt-3">
                            <li className="d-flex align-items-center mb-3">
                              <i className="bx bx-user" />
                              <span className="fw-medium mx-2">Fullname:</span>{" "}
                              <span>
                                {transactionDetailsInApi.second_party_first_name && titleCaseString(
                                  transactionDetailsInApi.second_party_first_name?.toUpperCase() +
                                  " " +
                                  transactionDetailsInApi.second_party_last_name?.toUpperCase()
                                )}
                              </span>
                            </li>

                            <li className="d-flex align-items-center mb-3">
                              <i className="bx bx-male-female" />
                              <span className="fw-medium mx-2">Gender:</span>{" "}
                              <span>{titleCaseString(transactionDetailsInApi?.second_party_gender)}</span>
                            </li>

                            <li className="d-flex align-items-center mb-3">
                              <i className="bx bx-calendar" />
                              <span className="fw-medium mx-2">Birthdate:</span>{" "}
                              <span>



                                {transactionDetailsInApi?.second_party_birth_date && DateFormatter(
                                  transactionDetailsInApi?.second_party_birth_date,
                                  "MM DD, YYYY"
                                )}
                              </span>
                            </li>

                          </ul>
                          <small className="text-muted text-uppercase">
                            Contacts
                          </small>
                          <ul className="list-unstyled mt-3">
                            <li className="d-flex align-items-center mb-3">
                              <i className="bx bx-phone" />
                              <span className="fw-medium mx-2">Contact:</span>
                              <span>{transactionDetailsInApi?.second_party_contact_number}</span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="bx bx-envelope" />
                              <span className="fw-medium mx-2">Email:</span>
                              <span>{transactionDetailsInApi?.second_party_email}</span>
                            </li>
                          </ul>
                        </div>
                      }

                    </div>
                  </div>
                }

                {/* Witnesses */}
                {transactionDetailsInApi.witnesses && transactionDetailsInApi.witnesses.length > 0 &&
                  <div className="col-md-12">
                    <div className="card mb-4">
                      {transactionDetailsInApi.witnesses.length > 0 &&
                        <div className="card-body">
                          <small className="fw-bolder text-black text-uppercase">
                            Witness(es) Information
                          </small>
                          <ul className="list-unstyled mb-4 mt-3">

                            {transactionDetailsInApi.witnesses.map((witness) => (
                                <li key={witness.transaction_id}>
                                  <strong>Contact #:</strong> {witness.contact_info} <br />
                                  <strong>Fullname:</strong> {witness.participant_fullname} <br />
                                  <strong>Profile Photo:</strong> {witness.participant_profile_photo} <br />
                                  <strong>Signature:</strong> {witness.participant_signature_path}
                                </li>
                              ))}

                          </ul>
                        
                         
                        </div>
                      }

                    </div>
                  </div>
                }
              </div>
            }

            

           


 
          </div>
        </>
      )}
    </>
  );
};

export default TechOathDetails;
